
      var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDifferentsvg = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 10.375,
  stroke: "#000",
  strokeWidth: 2.75
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M34.16 32.519c.276.197.558.251.845.162.287-.088.49-.29.61-.607a4.85 4.85 0 0 0 .297-1.037c.059-.356.088-.701.088-1.037a6.23 6.23 0 0 0-.43-2.267 5.448 5.448 0 0 0-1.322-1.97 6.04 6.04 0 0 0-1.917-1.26 6.038 6.038 0 0 0-2.123-.46l.417-.443a.888.888 0 0 0 .266-.651.94.94 0 0 0-.296-.683.894.894 0 0 0-.655-.266.892.892 0 0 0-.653.266l-2.347 2.313a.648.648 0 0 0-.208.473c0 .177.07.335.208.474l2.347 2.31a.89.89 0 0 0 .653.268.94.94 0 0 0 .684-.297.902.902 0 0 0 .267-.666.903.903 0 0 0-.266-.667l-.595-.563a4.92 4.92 0 0 1 1.53.312c.505.187.955.478 1.352.873.395.395.692.845.89 1.348.199.505.297 1.013.297 1.526 0 .257-.02.504-.06.741a3.183 3.183 0 0 1-.206.711.96.96 0 0 0-.03.623.846.846 0 0 0 .356.474zm-4.755 5.215a.894.894 0 0 0 .655.266.892.892 0 0 0 .653-.266l2.347-2.313a.648.648 0 0 0 .208-.473.651.651 0 0 0-.208-.474l-2.347-2.31a.926.926 0 0 0-.639-.282c-.247-.01-.47.083-.669.281a.904.904 0 0 0-.266.667c0 .267.089.489.266.666l.565.593a4.919 4.919 0 0 1-1.53-.312 3.758 3.758 0 0 1-1.352-.873 3.934 3.934 0 0 1-.89-1.348 4.152 4.152 0 0 1-.297-1.526c0-.257.02-.504.06-.741a3.18 3.18 0 0 1 .206-.711.878.878 0 0 0 0-.637.997.997 0 0 0-.385-.49c-.277-.177-.55-.216-.817-.118-.267.099-.46.297-.58.593a4.831 4.831 0 0 0-.297 1.037A6.342 6.342 0 0 0 24 30c0 .77.143 1.526.43 2.267a5.47 5.47 0 0 0 1.322 1.97 6.04 6.04 0 0 0 1.917 1.26c.702.286 1.41.44 2.123.46l-.417.443a.888.888 0 0 0-.266.651.94.94 0 0 0 .296.683z",
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M37 1.625A3.375 3.375 0 0 1 40.375 5v9.625c0 .76-.616 1.375-1.375 1.375H4.375v11c0 .345.28.625.625.625h9.625a1.375 1.375 0 1 1 0 2.75H5A3.375 3.375 0 0 1 1.625 27V5A3.375 3.375 0 0 1 5 1.625h32zM5 4.375A.625.625 0 0 0 4.375 5v4h33.25V5A.625.625 0 0 0 37 4.375H5z",
  fill: "#000"
})));

      const __svgRaw = "<svg width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <circle cx=\"30\" cy=\"30\" r=\"10.375\" stroke=\"#000\" stroke-width=\"2.75\"/>\r\n    <path d=\"M34.16 32.519c.276.197.558.251.845.162.287-.088.49-.29.61-.607.138-.336.237-.682.297-1.037.059-.356.088-.701.088-1.037a6.23 6.23 0 0 0-.43-2.267 5.448 5.448 0 0 0-1.322-1.97 6.04 6.04 0 0 0-1.917-1.26 6.038 6.038 0 0 0-2.123-.46l.417-.443a.888.888 0 0 0 .266-.651.94.94 0 0 0-.296-.683.894.894 0 0 0-.655-.266.892.892 0 0 0-.653.266l-2.347 2.313a.648.648 0 0 0-.208.473c0 .177.07.335.208.474l2.347 2.31a.89.89 0 0 0 .653.268c.258 0 .486-.099.684-.297a.902.902 0 0 0 .267-.666.903.903 0 0 0-.266-.667l-.595-.563c.514.02 1.024.124 1.53.312.505.187.955.478 1.352.873.395.395.692.845.89 1.348.199.505.297 1.013.297 1.526 0 .257-.02.504-.06.741a3.183 3.183 0 0 1-.206.711.96.96 0 0 0-.03.623.846.846 0 0 0 .356.474zm-4.755 5.215a.894.894 0 0 0 .655.266.892.892 0 0 0 .653-.266l2.347-2.313a.648.648 0 0 0 .208-.473.651.651 0 0 0-.208-.474l-2.347-2.31a.926.926 0 0 0-.639-.282c-.247-.01-.47.083-.669.281a.904.904 0 0 0-.266.667c0 .267.089.489.266.666l.565.593a4.919 4.919 0 0 1-1.53-.312 3.758 3.758 0 0 1-1.352-.873 3.934 3.934 0 0 1-.89-1.348 4.152 4.152 0 0 1-.297-1.526c0-.257.02-.504.06-.741.039-.237.107-.474.206-.711a.878.878 0 0 0 0-.637.997.997 0 0 0-.385-.49c-.277-.177-.55-.216-.817-.118-.267.099-.46.297-.58.593a4.831 4.831 0 0 0-.297 1.037A6.342 6.342 0 0 0 24 30c0 .77.143 1.526.43 2.267.288.74.728 1.397 1.322 1.97a6.04 6.04 0 0 0 1.917 1.26c.702.286 1.41.44 2.123.46l-.417.443a.888.888 0 0 0-.266.651.94.94 0 0 0 .296.683z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path d=\"M37 1.625A3.375 3.375 0 0 1 40.375 5v9.625c0 .76-.616 1.375-1.375 1.375H4.375v11c0 .345.28.625.625.625h9.625a1.375 1.375 0 1 1 0 2.75H5A3.375 3.375 0 0 1 1.625 27V5A3.375 3.375 0 0 1 5 1.625h32zM5 4.375A.625.625 0 0 0 4.375 5v4h33.25V5A.625.625 0 0 0 37 4.375H5z\" fill=\"#000\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/different.svg.5a05dc9427633d1ae3cbf23115d6c8ac.svg"),
        {
          React: SvgDifferentsvg,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      